/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './vaccination-schedule-details.reducer';

export const VaccinationScheduleDetails = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const vaccinationScheduleDetailsList = useAppSelector(state => state.vaccinationScheduleDetails.entities);
  const loading = useAppSelector(state => state.vaccinationScheduleDetails.loading);
  const totalItems = useAppSelector(state => state.vaccinationScheduleDetails.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="vaccination-schedule-details-heading" data-cy="VaccinationScheduleDetailsHeading">
        <Translate contentKey="tinyMedicRestApp.vaccinationScheduleDetails.home.title">Vaccination Schedule Details</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.vaccinationScheduleDetails.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link
            to="/vaccination-schedule-details/new"
            className="btn btn-primary jh-create-entity"
            id="jh-create-entity"
            data-cy="entityCreateButton"
          >
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.vaccinationScheduleDetails.home.createLabel">
              Create new Vaccination Schedule Details
            </Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.vaccinationScheduleDetails.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {vaccinationScheduleDetailsList && vaccinationScheduleDetailsList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.vaccinationScheduleDetails.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.vaccinationScheduleDetails.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('ageMax')}>
                  <Translate contentKey="tinyMedicRestApp.vaccinationScheduleDetails.ageMax">Age Max</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('ageMax')} />
                </th>
                <th className="hand" onClick={sort('ageMin')}>
                  <Translate contentKey="tinyMedicRestApp.vaccinationScheduleDetails.ageMin">Age Min</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('ageMin')} />
                </th>
                <th className="hand" onClick={sort('country')}>
                  <Translate contentKey="tinyMedicRestApp.vaccinationScheduleDetails.country">Country</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('country')} />
                </th>
                <th className="hand" onClick={sort('dosage')}>
                  <Translate contentKey="tinyMedicRestApp.vaccinationScheduleDetails.dosage">Dosage</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('dosage')} />
                </th>
                <th className="hand" onClick={sort('gender')}>
                  <Translate contentKey="tinyMedicRestApp.vaccinationScheduleDetails.gender">Gender</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('gender')} />
                </th>
                <th className="hand" onClick={sort('periodInDays')}>
                  <Translate contentKey="tinyMedicRestApp.vaccinationScheduleDetails.periodInDays">Period In Days</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('periodInDays')} />
                </th>
                <th className="hand" onClick={sort('risk')}>
                  <Translate contentKey="tinyMedicRestApp.vaccinationScheduleDetails.risk">Risk</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('risk')} />
                </th>
                <th className="hand" onClick={sort('vaccinationTypeCd')}>
                  <Translate contentKey="tinyMedicRestApp.vaccinationScheduleDetails.vaccinationTypeCd">Vaccination Type Cd</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('vaccinationTypeCd')} />
                </th>
                <th className="hand" onClick={sort('forYear')}>
                  <Translate contentKey="tinyMedicRestApp.vaccinationScheduleDetails.forYear">For Year</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('forYear')} />
                </th>
                <th className="hand" onClick={sort('timestampentry')}>
                  <Translate contentKey="tinyMedicRestApp.vaccinationScheduleDetails.timestampentry">Timestampentry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampentry')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.vaccinationScheduleDetails.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('lastupdated')}>
                  <Translate contentKey="tinyMedicRestApp.vaccinationScheduleDetails.lastupdated">Lastupdated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastupdated')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.vaccinationScheduleDetails.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.vaccinationScheduleDetails.schedule">Schedule</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.vaccinationScheduleDetails.vacciantion">Vacciantion</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {vaccinationScheduleDetailsList.map((vaccinationScheduleDetails, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/vaccination-schedule-details/${vaccinationScheduleDetails.id}`} color="link" size="sm">
                      {vaccinationScheduleDetails.id}
                    </Button>
                  </td>
                  <td>{vaccinationScheduleDetails.active ? 'true' : 'false'}</td>
                  <td>{vaccinationScheduleDetails.ageMax}</td>
                  <td>{vaccinationScheduleDetails.ageMin}</td>
                  <td>{vaccinationScheduleDetails.country}</td>
                  <td>{vaccinationScheduleDetails.dosage}</td>
                  <td>{vaccinationScheduleDetails.gender}</td>
                  <td>{vaccinationScheduleDetails.periodInDays}</td>
                  <td>{vaccinationScheduleDetails.risk}</td>
                  <td>{vaccinationScheduleDetails.vaccinationTypeCd}</td>
                  <td>{vaccinationScheduleDetails.forYear}</td>
                  <td>{vaccinationScheduleDetails.timestampentry}</td>
                  <td>{vaccinationScheduleDetails.microSec}</td>
                  <td>{vaccinationScheduleDetails.lastupdated}</td>
                  <td>{vaccinationScheduleDetails.cursor}</td>
                  <td>
                    {vaccinationScheduleDetails.schedule ? (
                      <Link to={`/vaccination-schedule/${vaccinationScheduleDetails.schedule.id}`}>
                        {vaccinationScheduleDetails.schedule.id}
                      </Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {vaccinationScheduleDetails.vacciantion ? (
                      <Link to={`/vaccination/${vaccinationScheduleDetails.vacciantion.id}`}>
                        {vaccinationScheduleDetails.vacciantion.id}
                      </Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/vaccination-schedule-details/${vaccinationScheduleDetails.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/vaccination-schedule-details/${vaccinationScheduleDetails.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/vaccination-schedule-details/${vaccinationScheduleDetails.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.vaccinationScheduleDetails.home.notFound">
                No Vaccination Schedule Details found
              </Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={vaccinationScheduleDetailsList && vaccinationScheduleDetailsList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default VaccinationScheduleDetails;
